<template>
  <div style="width: 100%">
    <hr />
    <div class="record-labels d-flex align-items-center justify-content-end">
      <el-button v-if="showLogButton" size="small" type="info" plain @click="$emit('show-logs')" class="mr-2">
        <i class="fa-solid fa-file-alt"></i>
      </el-button>


      <div class="labels-wrapper">
        <span class="record-label">{{ $t('Daxil_olunub') }}: {{ c }}</span>
        <span class="record-label" v-if="shouldShowUpdated">
          {{ $t('Düzəliş_olunub') }}: {{ u }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      created: String,
      updated: String,
      showLogButton: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        c: this.created,
        u: this.updated,
      };
    },
    computed: {
      shouldShowUpdated() {
        if (!this.u) return false;

        const trimmedDate = this.u.trim();
        const invalidDates = [
          "01.01.0001 00:00:00",
          "0001-01-01T00:00:00",
          "0001-01-01 00:00:00",
        ];

        return !invalidDates.includes(trimmedDate);
      },
    },
    watch: {
      created() {
        this.c = this.created;
      },
      updated() {
        this.u = this.updated;
      },
    },
  };
</script>

<style scoped>
  .record-labels {
    margin-top: 4px;
    min-width: 200px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
  }

  .labels-wrapper {
    display: flex;
    flex-direction: column;
  }

  .record-label {
    font-size: 9px;
    font-style: italic;
    margin-top: 2px;
  }

  .mr-2 {
    margin-right: 8px;
  }
</style>